import { observer } from "mobx-react";
import React from "react";
import { Modal, Stack, Text, Card, Group, Badge } from "@mantine/core";
import { Cubby } from "../../stores/Cubby";
import {
  MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS,
  MODALS,
} from "../../helpers/constants";
import _ from "lodash";
import { TextWithInfo } from "../modals/textWithInfo";
import { TextWithInfoAndIcon } from "./textWithInfoAndIcon";
import { ARTICLES } from "../../docs/docsIndex";
import { IconUsers } from "@tabler/icons-react";

const ShowPeers = observer(({ cubby }: { cubby: Cubby }) => {
  return (
    <>
      <Modal
        opened={cubby.currentModal === MODALS.SHOW_PEERS}
        onClose={() => cubby.setModal(null)}
        size={MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS}
        title={
          <TextWithInfoAndIcon
            text="Current Peers"
            articleSlug={ARTICLES.ADD_PEER.slug}
            icon={<IconUsers size={24} />}
            cubby={cubby}
            textSize="lg"
          />
        }
      >
        <Stack>
          <Text>
            These are the peers that your node is currently connected to.
          </Text>

          {_.sortBy(cubby.peerLists.data, "alias").map((peer) => {
            const isTor = peer.socket.includes("onion");

            return (
              <Card
                key={peer.public_key}
                shadow="sm"
                padding="sm"
                radius="md"
                withBorder
              >
                <Group justify="space-between" mb="xs">
                  <Text fw={500}>
                    {peer.alias || peer.public_key.slice(0, 9)}
                  </Text>
                  <Badge color={"var(--mantine-color-gray-8)"}>
                    {isTor ? "TOR" : "Clearnet"}
                  </Badge>
                </Group>

                <Text size="sm" c="dimmed" fw={500}>
                  Socket
                </Text>
                <Text size="sm" style={{ wordBreak: "break-word" }}>
                  {peer.socket}
                </Text>

                <Text size="sm" c="dimmed" fw={500}>
                  Public Key
                </Text>
                <Text size="sm" style={{ wordBreak: "break-word" }}>
                  {peer.public_key}
                </Text>
              </Card>
            );
          })}
        </Stack>
      </Modal>
    </>
  );
});

export default ShowPeers;
